import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminComparisons from "@/pages/admin/AdminComparisons";

export const Route = createFileRoute("/admin/comparisons")({
  component: () => (
    <ProtectedRoute>
      <AdminComparisons />
    </ProtectedRoute>
  ),
});
